<span *ngIf="favoriteProducts.length" class="page-title">Favorites</span>

<app-products
  [products]="favoriteProducts"
  [showTrash]="true"
  (productClicked)="onProductClick($event)"
  (trashClicked)="onTrashClick($event)"
></app-products>

<app-state-message
  *ngIf="!favoriteProducts.length"
  [title]="'Favorites is empty'"
  [subtitle]="'Keep looking for the best outfits in our site'"
></app-state-message>
